/**
 * Icon button that copies a value to the clipboard and toasts the result.
 *
 * @module ui/components/CopyIconButton
 */
import React from 'react';
import { Button, useToast } from '@chatsdet/ui';
import { Check, CopySimple } from '@phosphor-icons/react';
import { copyTextToClipboard } from './settings/clipboard-copy';

export function CopyIconButton({ value, label }: { value: string; label: string }) {
  const { toast } = useToast();
  const [copied, setCopied] = React.useState(false);

  const handleCopy = async () => {
    if (await copyTextToClipboard(value)) {
      setCopied(true);
      toast.success(`Copied ${label}`);
      window.setTimeout(() => setCopied(false), 1200);
    } else {
      toast.error('Failed to copy');
    }
  };

  return (
    <Button variant="ghost" size="sm" iconOnly aria-label={`Copy ${label}`} onPress={handleCopy}>
      {copied ? <Check size={14} /> : <CopySimple size={14} />}
    </Button>
  );
}
